import { IxcRegistrationV1CheckOutcome } from '@interxfi/types/generated/api';

export function determineIfRegistrationOutcomeRequiresAction(outcome: IxcRegistrationV1CheckOutcome | undefined) {
  return !outcome || outcome === IxcRegistrationV1CheckOutcome.Inconclusive;
}
